import React from "react";
import "../../App.css";

const Loader = ({ loaderTransform, loaderTransForm }) => {
  const loaderClassName = [loaderTransform, loaderTransForm].filter(Boolean).join(" ");

  return (
    <div className={`loaderBg ${loaderClassName}`.trim()}>
      <div className="loaderArea"></div>
    </div>
  );
};

export default Loader;
